import React from 'react';
import stable from 'stable';
import { Card, CardBody, Col, Badge, Table, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import countries from 'i18n-iso-countries';
import translateProfession from 'translations/dynamicTranslator';
import { CONFIG } from 'constants/config';

class DelavciTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      employeesOriginal: props.employees,
      employees: props.employees,
      selectedSort: 'default',
    };
  }

  // sortWorkers = workers => {
  //   //const lexCmpName = (a, b) => CONFIG.COLLATOR.compare(a.name, b.name);
  //   const lexCmpSurname = (a, b) => CONFIG.COLLATOR.compare(a.surname, b.surname);
  //   const byName = stable(workers, lexCmpName);
  //   const bySurname = stable(byName, lexCmpSurname);
  //   return bySurname;
  // };

  sortByIzkaznica = () => {
    const { selectedSort, employeesOriginal } = this.state;
    if (selectedSort === 'izkaznica') {
      this.setState({ employees: employeesOriginal, selectedSort: 'default' });
      return;
    }

    const lexCmpIzkaznica = (a, b) => CONFIG.COLLATOR.compareDates(Number(b.izkaznica), Number(a.izkaznica));
    const byIzkaznica = stable(employeesOriginal, lexCmpIzkaznica);
    this.setState({ employees: byIzkaznica, selectedSort: 'izkaznica' });
  };

  sortBySurname = () => {
    const { selectedSort, employeesOriginal } = this.state;
    if (selectedSort === 'surname') {
      this.setState({ employees: employeesOriginal, selectedSort: 'default' });
      return;
    }

    const lexCmpSurname = (a, b) => CONFIG.COLLATOR.compare(a.surname, b.surname);
    const bySurname = stable(employeesOriginal, lexCmpSurname);
    this.setState({ employees: bySurname, selectedSort: 'surname' });
  };

  renderTable = () => {
    const { onRowSelect } = this.props;
    const { employees } = this.state;
    return employees.map((employee, index) => (
      <tr key={`${employee.id}`} id={employee.id} onClick={onRowSelect.bind(this, employee.id)}>
        {/* <td>{index + 1}</td> */}
        <td>{employee.izkaznica}</td>
        <td>
          <Badge style={{ backgroundColor: `${employee.color}`, color: '#646777' }}>{employee.company}</Badge>
        </td>
        <td>{employee.surname}</td>
        <td>{employee.name}</td>
        <td>{employee.birthDateString}</td>
        <td>{employee.address}</td>
        <td>{employee.city}</td>
        <td>{employee.registeredAt}</td>
      </tr>
    ));
  };

  render() {
    const { title, t } = this.props;
    //const { selectedSort } = this.state;

    return (
      <Col md={12} lg={12} xl={12}>
        <Card>
          <CardBody>
            <div className="card__title delavci-table__title">
              <h5 className="bold-text">Igralci</h5>
            </div>
            <Table hover className="table--bordered" responsive>
              <thead>
                <tr>
                  {/* <th>#</th> */}
                  <th>
                    <Button
                      size="sm"
                      className="form-assignments-add-worker-btn"
                      color="link"
                      style={{ padding: 0, margin: 0 }}
                      onClick={this.sortByIzkaznica}
                    >
                      Št. izkaznice
                    </Button>
                  </th>
                  <th>Ekipa</th>
                  <th>
                    <Button
                      size="sm"
                      className="form-assignments-add-worker-btn"
                      color="link"
                      style={{ padding: 0, margin: 0 }}
                      onClick={this.sortBySurname}
                    >
                      Priimek
                    </Button>
                  </th>
                  <th>{t('form.name')}</th>
                  <th>Rojstni datum</th>

                  <th>{t('form.address')}</th>

                  <th>{t('form.city')}</th>
                  <th>Pravica nastopa</th>
                </tr>
              </thead>
              <tbody>{this.renderTable()}</tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

DelavciTable.propTypes = {
  title: PropTypes.string.isRequired,
  employees: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRowSelect: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate('common')(DelavciTable);
